/**
 * Build-time feature flags, read once at module load from Vite env vars
 * (same convention as `App.tsx`'s `IS_E2E_TEST_MODE`). No runtime toggle —
 * flipping one of these requires a rebuild/redeploy with the env var set.
 */

/**
 * PMA-COCK-179 (2026-09-10, client request via the team lead): the "Análisis
 * IA" block (narrative, NL question, chat) rendered as a fixed panel under
 * the pass map / heat maps on the iPad and got in the way of the analytics
 * presentation. Hides both AI surfaces — `AiInsightsPanel` (mounted in
 * `AnalyticsView.tsx`) and the desktop `FloatingAiChat` (mounted in
 * `LoggerCockpit.tsx`) — behind this flag, default OFF (unset in every
 * deploy environment hides both). Code, tests, and the `ai-insights-*` /
 * `floating-ai-chat*` testids are retained; flip this env var to bring the
 * feature back with no code change. See cockpit-contract.md PMA-COCK-179
 * and the On-hold notes on PMA-COCK-052/068/069/070.
 */
export const AI_INSIGHTS_ENABLED =
  import.meta.env.VITE_AI_INSIGHTS_ENABLED === "true";
